<template>
  <div class="vx-row">
    <home-menu-item :roles="['ABCReaders', 'Admin']" icon="DollarSignIcon" :title="$t('ABC.Title')" link="/abc" />
    <home-menu-item :roles="['CashflowReaders', 'KPUReaders', 'CashflowWriter', 'DecarbonizationReaders', 'DecarbonizationCollaborators', 'Admin']" icon="DollarSignIcon" :title="$t('BSG.Title')" link="/bsg" />
    <home-menu-item :roles="['GeoReaders', 'MRMRReaders', 'Admin']" icon="MapIcon" :title="$t('MRMR.Title')" link="/mrmr" />
    <home-menu-item :roles="['GradeControlReaders', 'Admin']" icon="ClockIcon" :title="$t('GradeControl.Title')" link="/geo/gradecontrol" />
    <home-menu-item :roles="drillPages.mainMenu.roles" :icon="drillPages.mainMenu.icon" :title="$t(drillPages.mainMenu.i18nTitle)" :link="drillPages.mainMenu.path" />
  </div>
</template>

<script>
import drillingPages from '@/app/drilling/pages.js';
import homeMenuItem from '@/app/shared/components/lists/home-menu-item.vue';

const drillPages = new drillingPages();

export default {
  components: {
    homeMenuItem
  },
  data () {
    return {
      drillPages
    }
  }
}
</script>